import { getValue, forEach } from '@/utils/helpers'

const TOKEN = 'fbf3c898441e7b2522ad2656f328151207143c38'

const dadataTypes = {
  surname: 'SURNAME', // подсказка по фамилии
  name: 'NAME', // подсказка по имени
  patronymic: 'PATRONYMIC', // подсказка по отчеству
  email: 'EMAIL', // подсказка по email
  city: 'city', // подсказка по городу
  region: 'region', // подсказка по региону
  street: 'street', // подсказка только по улице
  address: 'address', // подсказка по всему адресу в строчку (город, улица, дом)
  party: 'party', // Поиск организаций
  inn: 'inn', // подсказка по ИНН
  house: 'house' // подсказка по дому
}

// какой справочник вызывать у dadata.ru в зависимости от ${props.dadataType}
const dadataDictionary = type => {

  switch (type) {
    case 'surname':
    case 'name':
    case 'patronymic':
      return 'fio'
    case 'email':
      return 'email'
    case 'city':
    case 'street':
    case 'region':
    case 'address':
    case 'house':
      return 'address'
    case 'inn':
    case 'party':
      return 'party'
    default:
      return 'fio'
  }
}

export function getInformationAboutIP () {
  return fetch(
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address',
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: 'Token ' + TOKEN
      }
    }
  )
    .then(response => response.json())
    .catch(error => console.error('getInformationAboutIP', error))
}

export default {
  props: {
    /**
     * тип подсказки
     */
    dadataType: {
      type: String,
      default: '',
      validator (value) {
        return [''].concat(Object.keys(dadataTypes)).includes(value)
      }
    },
    /**
     * поиск по кладр
     */
    dadataKladrId: {
      type: String
    },
    /**
     * функция фильтрации подсказок
     */
    dadataFilter: {
      type: Function
    }
  },
  data () {
    return {
      dadataTimer: null,
      dadataItems: [], // подсказки от дадаты
      selectedDadataItem: false, // было выбрано из подсказок дадаты
      activeItemIndex: null, // index активного элемента
      stopRequestDadata: false, // остановить запросы за данными
    }
  },
  mounted () {
    this.$on('input', this.onChangeValueDadata)
  },
  beforeDestroy () {
    this.$off('input', this.onChangeValueDadata)
  },
  methods: {
    onChangeValueDadata (value) {

      if (this.stopRequestDadata) {
        return
      }

      // подсказки не нужны
      if (!this.dadataType) {
        return
      }

      clearTimeout(this.dadataTimer)

      this.dadataTimer = setTimeout(() => {
        this.getSuggestions(value)
      }, 200)
    },

    dadataItemClicked (item) {

      // default
      let { value } = item

      // city
      if (this.dadataType === 'city') {
        value = getValue(item, 'data.city_with_type') || getValue(item, 'data.city', value)
      }

      // region
      if (this.dadataType === 'region') {
        value = getValue(item, 'data.region_with_type') || getValue(item, 'data.region', value)
      }

      // street
      if (this.dadataType === 'street') {
        value = getValue(item, 'data.street_with_type') || getValue(item, 'data.street', value)
      }

      // inn
      if (this.dadataType === 'inn') {
        value = getValue(item, 'data.inn')
      }

      // party
      if (this.dadataType === 'party') {
        value = getValue(item, 'data.name.short') || value
      }

      this.stopRequestDadata = true

      this.updateValue(value)

      this.dadataItems = []

      this.$nextTick(() => {
        setTimeout(() => {
          this.stopRequestDadata = false
        }, 300)
      })

      this.$emit('suggestion', { ...item, cleanValue: value })

      const kladrId = getValue(item, 'data.kladr_id')

      if (kladrId) {
        this.$emit('kladrId', kladrId)
      }

      this.selectedDadataItem = true
    },

    getSuggestions (query) {
      const url = `https://dadata.ru/api/v2/suggest/${dadataDictionary(this.dadataType)}`

      const headers = {
        Accept: 'application/json',
        Authorization: 'Token ' + TOKEN
      }

      headers['Content-Type'] = 'application/json'

      return fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          count: 3,
          query,
          ...this.formSuggestionsData()
        })
      })
        .then(r => r.json())
        .then(res => res.suggestions)
        .then(items => {
          if (typeof this.dadataFilter === 'function') {
            this.dadataItems = this.formDadataItems(this.dadataFilter(items))
          } else {
            this.dadataItems = this.formDadataItems(items)
          }

          return this.dadataItems
        })
    },

    formDadataItems (items) {

      // party
      if (this.dadataType === 'party') {
        return items.map(item => ({
          ...item,
          hint: `${item.data.inn} ${getValue(item, 'data.management.name')}`
        }))
      }

      // inn
      if (this.dadataType === 'inn') {
        return items.map(item => ({
          ...item,
          hint: `${item.data.inn} ${getValue(item, 'data.address.value')}`
        }))
      }

      return items
    },

    formSuggestionsData () {

      // address
      if (this.dadataType === 'address') {
        return {}
      }

      // address - city,region,street,house
      if (~['city', 'region', 'street', 'house'].indexOf(this.dadataType)) {

        return {
          from_bound: { value: this.dadataType },
          to_bound: { value: this.dadataType },
          locations: this.dadataKladrId ? [{ kladr_id: this.dadataKladrId }] : [],
          restrict_value: this.dadataType === 'house'
        }
      }

      // default
      return {
        parts: [dadataTypes[this.dadataType]]
      }
    },

    listenDadataEvents () {
      document.addEventListener('keydown', this.onKeyDown)
    },

    unlistenDadataEvents () {
      this.activeItemIndex = null
      document.removeEventListener('keydown', this.onKeyDown)
    },

    onKeyDown (e) {

      const lengthItems = this.dadataItems.length

      // нет подсказок
      if (!lengthItems) {
        return
      }

      const { keyCode } = e

      if (!~[38, 40, 13].indexOf(keyCode)) {
        return
      }

      e.stopPropagation()
      e.preventDefault()

      // up
      if (keyCode === 38) {

        if (this.activeItemIndex === null) {
          this.activeItemIndex = lengthItems - 1
        } else {
          this.activeItemIndex = this.activeItemIndex - 1 >= 0 ? this.activeItemIndex - 1 : lengthItems - 1
        }
      }

      // down
      if (keyCode === 40) {

        if (this.activeItemIndex === null) {
          this.activeItemIndex = 0
        } else {
          this.activeItemIndex = this.activeItemIndex + 1 <= lengthItems - 1 ? this.activeItemIndex + 1 : 0
        }
      }

      // enter
      const activeItem = this.dadataItems[this.activeItemIndex]

      if (keyCode === 13 && activeItem) {
        this.dadataItemClicked(activeItem)
      }
    },

    // если пользователь что то написал но не выбрал из подсказок дадаты - сделаем выбор за него
    async findDadataItem () {

      let { dadataItems } = this

      if (!dadataItems.length) {
        dadataItems = await this.getSuggestions(this.observableValue)
      }

      const observableValue = this.clearDadataValue(this.observableValue)

      // поиск строгого соответствия
      const dadataItem = dadataItems.find(item => this.clearDadataValue(item.value) === observableValue)

      if (dadataItem) {
        this.dadataItemClicked(dadataItem)
        return
      }

      // для фио, email не будем искать вхождения
      if (~['surname', 'name', 'patronymic', 'email', 'inn', 'party', 'house'].indexOf(this.dadataType)) {
        return
      }

      // поиск вхождения строк
      const valueChunks = observableValue.split(' ')

      const dadataItem2 = dadataItems.find(item => {
        const value = this.clearDadataValue(item.value)
        let finded = true

        forEach(valueChunks, chunk => {
          if (!~value.indexOf(chunk)) {
            finded = false

            return false
          }
        })

        return finded
      })

      if (dadataItem2) {
        this.dadataItemClicked(dadataItem2)
      }
    },

    clearDadataValue (value) {
      value = String(value)

      value = value.replace(/(,|\.)/g, ' ')
      value = value.replace(/(г |ул |д |с\/с |поселок |респ |село | р-н|тер )/g, ' ')
      value = value.replace(/( )+/g, ' ')

      return value.toLowerCase()
    }
  },
  watch: {
    inFocus (inFocus) {

      // подсказки не нужны
      if (!this.dadataType) {
        return
      }

      if (inFocus) {
        this.listenDadataEvents()
      } else {
        this.unlistenDadataEvents()
      }

      // пользователь попал в поле ввода - запросим подсказки
      if (inFocus && this.observableValue && !this.dadataItems.length) {
        this.getSuggestions(this.observableValue)
      }

      // если пользователь что то написал но не выбрал из подсказок дадаты - сделаем выбор за него
      if (!inFocus && this.observableValue && !this.selectedDadataItem) {
        this.findDadataItem()
      }
    },

    edited (edited) {
      // подсказки не нужны
      if (!this.dadataType) {
        return
      }

      if (edited) {
        this.selectedDadataItem = false
      }
    },

    dadataKladrId () {
      this.dadataItems = []
      this.selectedDadataItem = false
    }
  }
}
